import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

const TaskScheduleHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Tareas Programadas"
    text="Éste es el módulo de Tareas Programadas."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = ({ TaskScheduleUnit }) => ({
  cards: TaskScheduleUnit.UnitHome.get('cards'),
  breadcrumbs: TaskScheduleUnit.UnitHome.get('breadcrumbs'),
});

TaskScheduleHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(TaskScheduleHome);
